exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-dashboard-widgets-___widget-action__actions___1RA8k {\n  font-size: 16px;\n  top: 0;\n  right: 0;\n  left: 0;\n  position: absolute;\n  display: none;\n  z-index: 10000;\n}\n\n.src-components-dashboard-widgets-___widget-action__actions___1RA8k > div {\n  display: flex;\n}\n\n.src-components-dashboard-widgets-___widget-action__actions___1RA8k i {\n  margin-left: 5px;\n  color: #5d8ce3;\n  background-color: white;\n}", ""]);

// exports
exports.locals = {
	"actions": "src-components-dashboard-widgets-___widget-action__actions___1RA8k"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/widget-action.scss
// module id = 2314
// module chunks = 0